var map = {
	"./1.png": 4143,
	"./2.png": 1189,
	"./3.png": 9746,
	"./4.png": 5870,
	"./Righe/1/1.png": 8132,
	"./Righe/1/2.png": 719,
	"./Righe/1/3.png": 1231,
	"./Righe/1/4.png": 177,
	"./Righe/2/1.png": 9179,
	"./Righe/2/2.png": 4653,
	"./Righe/2/3.png": 404,
	"./Righe/2/4.png": 3238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8037;